import { useState } from "react";
import { IconButton, Button, Grid } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { FDocumentoItemtyle } from "./FDocumentoItem";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { obtenerVouchers, clearVouchers, dowloadVoucherAction } from "../../../ducks/voucherIndividualDuck";
import IconDowload from "@material-ui/icons/GetApp"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
})

const TablaVoucher = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { vouchers } = useSelector(store => store.vouchersIndividual)
    const rows = vouchers
    const onDowload = ({ idVoucher }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(dowloadVoucherAction({ idDocumento: idVoucher })).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: Response.contentType }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            link.download = `Compra Item ${idVoucher}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="caption table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Nombre</TableCell>
                        <TableCell align="center">Acción</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.IdCompraIndividualDocumento}>
                            <TableCell align="center" >
                                {row.Nombre}
                            </TableCell>
                            <TableCell align="center">
                                <div>
                                    <IconButton variant="outlined" color="primary" onClick={() => onDowload({ idVoucher: row.IdCompraIndividualDocumento })}>
                                        <IconDowload />
                                    </IconButton>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
const TVoucher = (props) => {
    const { Compra } = props
    const classes = FDocumentoItemtyle()
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch()
    const onClick = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerVouchers({ idCompra: Compra.idCompra })).then(Resposne => {
            dispatch(offLoadAction())
        })
        setOpen(true)
    }
    const handleClose = () => {
        dispatch(clearVouchers())
        setOpen(false)
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick}>
                Descargar
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Comprobante pago de Item"
                />
                <div style={{ height: "15rem", overflowY: "scroll" }}>
                    <TablaVoucher Compra={Compra} />
                </div>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            onClick={handleClose}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
        </div>
    )
}
export default TVoucher
